import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ReplaySubject, Subject, distinctUntilChanged, takeUntil } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';

import { CategoryCardContentlet } from '../../models/dot-cms-uve-contentlet.model';

@Component({
  selector: 'custom-dot-cms-uve-master-category-card',
  templateUrl: './dot-cms-uve-master-category-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-uve-master-category-card.component.scss'],
  imports: [AsyncPipe, RouterLink],
})
export class DotCmsUveMasterCategoryCardComponent implements OnInit {
  readonly contentlet = input<CategoryCardContentlet>(undefined);
  private destroy$ = new Subject<void>();
  categoryUniqueIds: string[];
  fetchedCategories$ = new ReplaySubject<CategoryView[]>(1);
  categoriesFetched: CategoryView[];
  private shoppingFacade = inject(ShoppingFacade);

  ngOnInit() {
    this.categoryUniqueIds = this.contentlet().allCategories.split(',');
    this.getCategories(this.categoryUniqueIds);
  }

  //Todo: Code refactor required
  getCategories(categoryUniqueIds: string[]) {
    const categories: Map<string, CategoryView> = new Map();
    categoryUniqueIds.forEach(uniqueId => {
      this.shoppingFacade
        .getSingleCategoryByUniqueId$(uniqueId)
        .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe(category => {
          categories.set(uniqueId, category);
          this.categoriesFetched = [];
          categories.forEach(category => {
            this.categoriesFetched.push(category);
          });
          this.categoriesFetched = this.categoriesFetched.filter(category => category !== undefined);

          if (categories.size === categoryUniqueIds.length && this.categoriesFetched.length > 0) {
            this.fetchedCategories$.next(this.categoriesFetched);
          }
        });
    });
  }
}
